<template>
  <div class="uk-grid uk-grid-small uk-margin-top" uk-grid>
    <div :class="{'uk-width-1-2@l': tenant.knumber !== 'K10140', 'uk-width-1-1': tenant.knumber === 'K10140' }">
      <div class="uk-h4">Beschreibung</div>
      <div v-html="vehicle.description"></div>
    </div>
    <div class="uk-width-expand@l" v-if="tenant.knumber !== 'K10140'">
      <div class="uk-grid uk-grid-small uk-text-small" uk-grid>
        <div class="uk-width-1-1">
          <div class="uk-h4">Ausstattung</div>
        </div>
        <div class="uk-width-1-2@s">
          <template v-if="vehicle.features.comfort">
            <p class="uk-margin-remove-bottom">
              <strong>Innenausstattung / Komfort</strong>
            </p>

            <ul class="uk-list uk-margin-small-top">
              <li
                class="uk-margin-remove"
                v-for="(feature, i) in vehicle.features.comfort"
                :key="i"
              >
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: check"></span>
                {{ feature }}
              </li>
            </ul>
          </template>

          <template v-if="vehicle.features.extras">
            <p class="uk-margin-remove-bottom">
              <strong>Extras in der Ausstattung</strong>
            </p>

            <ul class="uk-list uk-margin-small-top">
              <li class="uk-margin-remove" v-for="(feature, i) in vehicle.features.extras" :key="i">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: check"></span>
                {{ feature }}
              </li>
            </ul>
          </template>
        </div>

        <div class="uk-width-1-2@s">
          <template v-if="vehicle.features.exterior">
            <p class="uk-margin-remove-bottom">
              <strong>Aussenausstattung</strong>
            </p>

            <ul class="uk-list uk-margin-small-top">
              <li
                class="uk-margin-remove"
                v-for="(feature, i) in vehicle.features.exterior"
                :key="i"
              >
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: check"></span>
                {{ feature }}
              </li>
            </ul>
          </template>
          <template v-if="vehicle.features.enviroment">
            <p class="uk-margin-remove-bottom">
              <strong>Sicherheit</strong>
            </p>

            <ul class="uk-list uk-margin-small-top">
              <li
                class="uk-margin-remove"
                v-for="(feature, i) in vehicle.features.enviroment"
                :key="i"
              >
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: check"></span>
                {{ feature }}
              </li>
            </ul>
          </template>
          <template v-if="vehicle.features.more">
            <p class="uk-margin-remove-bottom">
              <strong>Andere</strong>
            </p>

            <ul class="uk-list uk-margin-small-top">
              <li class="uk-margin-remove" v-for="(feature, i) in vehicle.features.more" :key="i">
                <span class="uk-margin-small-right uk-icon" uk-icon="icon: check"></span>
                {{ feature }}
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    vehicle: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['tenant'])
  }
}
</script>
